import { Image, StyleSheet } from "@react-pdf/renderer";
import { REPORT_ASSETS } from "../../utils/mapers";
import { normalizeText } from "../../utils/utils";

const styles = StyleSheet.create({
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
  },

  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
});

export default function ReportStyle({ disciplina }) {
  const assets = REPORT_ASSETS[
    normalizeText(disciplina).includes("lenguaje")
      ? "lenguaje"
      : "matematica"
  ];

  return (
    <>
      <Image fixed cache src={assets.header} style={styles.header} />
      <Image fixed cache src={assets.footer} style={styles.footer} />
    </>
  );
}
